module.exports = __webpack_public_path__ + "static/media/zl_2_13.4b658faa.png";